module.exports = __webpack_public_path__ + "img/previne.079b799c.png";